"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.type.text': 'Text',
    'question.type.textarea': 'Textarea',
    'question.type.select': 'Select',
    'question.type.radio': 'Radio',
    'question.type.checkbox': 'Checkbox',
    'question.type.number': 'Number',
    'question.type.email': 'Email',
    'question.type.url': 'URL',
    'question.type.date': 'Date',
};
